// extracted by mini-css-extract-plugin
export default {"cls1":"Base-cls1__0K","cls2":"Base-cls2_xis Base-cls1__0K"};